import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {Injectable} from "@angular/core";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {NovaConta} from "../empresa/models/nova-conta";
import {FinanceiroDashboard} from "../empresa/models/financeiro-dashboard";
import {Orcamento} from "../empresa/models/orcamento";
import {BaixarConta} from "../empresa/models/baixar-conta";

@Injectable({
  providedIn: 'root'
})
export class FinanceiroService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`FinanceiroService`);
  }

  baseUrl = environment.apiUrl;

  salvarContaAPagar(request: NovaConta): Observable<BaseResponse<any>> {
    return this.http
      .post<BaseResponse<any>>(`${this.baseUrl}/financeiro/contaApagar`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('salvarContaAPagar')));
  }

  salvarContaAReceber(request: NovaConta): Observable<BaseResponse<any>> {
    return this.http
      .post<BaseResponse<any>>(`${this.baseUrl}/Financeiro/contaAreceber`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('salvarContaAReceber')));
  }

  alterarConta(request: NovaConta): Observable<BaseResponse<any>> {
    return this.http
      .put<BaseResponse<any>>(`${this.baseUrl}/financeiro/conta`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('alterarConta')));
  }

  obterDashboard(): Observable<BaseResponse<FinanceiroDashboard>> {
    return this.http
      .get<BaseResponse<FinanceiroDashboard>>(`${this.baseUrl}/Financeiro/Dashboard`)
      .pipe(catchError(this.handlerErro<BaseResponse<FinanceiroDashboard>>('obterDashboard')));
  }

  obterContasAPagar(): Observable<BaseResponse<any[]>> {
    return this.http
      .get<BaseResponse<any[]>>(`${this.baseUrl}/financeiro/contasapagar`)
      .pipe(catchError(this.handlerErro<BaseResponse<any[]>>('obterContasAPagar')));
  }

  obterContasAReceber(): Observable<BaseResponse<any[]>> {
    return this.http
      .get<BaseResponse<any[]>>(`${this.baseUrl}/financeiro/contasareceber`)
      .pipe(catchError(this.handlerErro<BaseResponse<any[]>>('obterContasAReceber')));
  }

  obterContaPorId(id: number): Observable<BaseResponse<any>> {
    return this.http
      .get<BaseResponse<any>>(`${this.baseUrl}/Financeiro/Conta/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('obterContaPorId')));
  }

  obterOrcamentos(data: string): Observable<BaseResponse<Orcamento[]>> {
    return this.http
      .get<BaseResponse<Orcamento[]>>(`${this.baseUrl}/Financeiro/Orcamentos`, { params: { data } })
      .pipe(catchError(this.handlerErro<BaseResponse<Orcamento[]>>('obterOrcamentos')));
  }

  obterOrcamentoPorId(id: number): Observable<BaseResponse<Orcamento>> {
    return this.http
      .get<BaseResponse<Orcamento>>(`${this.baseUrl}/Financeiro/Orcamento/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<Orcamento>>('obterOrcamentoPorId')));
  }

  salvarOrcamento(request: any): Observable<BaseResponse<any>> {
    return this.http
      .post<BaseResponse<any>>(`${this.baseUrl}/Financeiro/Orcamento`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('salvarOrcamento')));
  }

  alterarOrcamento(request: any): Observable<BaseResponse<any>> {
    return this.http
      .put<BaseResponse<any>>(`${this.baseUrl}/Financeiro/Orcamento`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('alterarOrcamento')));
  }

  deletarOrcamento(id: number): Observable<BaseResponse<any>> {
    return this.http
      .delete<BaseResponse<any>>(`${this.baseUrl}/Financeiro/Orcamento/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('deletarOrcamento')));
  }

  baixarContaAPagar(request: BaixarConta): Observable<BaseResponse<any>> {
    return this.http
      .patch<BaseResponse<any>>(`${this.baseUrl}/financeiro/baixarcontaapagar`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('baixarContaAPagar')));
  }

  baixarContaAReceber(request: BaixarConta): Observable<BaseResponse<any>> {
    return this.http
      .patch<BaseResponse<any>>(`${this.baseUrl}/financeiro/baixarcontaareceber`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('baixarContaAReceber')));
  }

  deletarConta(id: number): Observable<BaseResponse<any>> {
    return this.http
      .delete<BaseResponse<any>>(`${this.baseUrl}/Financeiro/Conta/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('deletarConta')));
  }
}
